export const EULA_LINK =
  process.env.NEXT_PUBLIC_BREEDLOGIC_UI_URI + '/abri-eula.pdf';
export const PRIVACY_POLICY_LINK =
  process.env.NEXT_PUBLIC_BREEDLOGIC_UI_URI + '/privacy-policy.pdf';
export const SUPPORT_LINK =
  'https://abri-support.atlassian.net/servicedesk/customer/portal/43';
